import CareersPage from "@components/careers-page";
import { loadTranslation } from "@lib/utils";
import { GetStaticProps } from "next";
import { t } from "@lingui/macro";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const translation = await loadTranslation(
    locale,
    process.env.NODE_ENV == "production"
  );

  return { props: { translation, locale } };
};

const Careers: React.FunctionComponent = () => {
  const router = useRouter();
  const { locale } = router;
  const seoLocale = "/" + locale;
  const title = t`Careers - Lumi News`;
  const description = t`Considering a career at Lumi News? Discover job opportunities and apply for roles you're interested in.`;
  return (
    <>
      <NextSeo
        title={title}
        description={description}
        openGraph={{
          url: `https://luminews.my${
            seoLocale.includes("en") ? "" : seoLocale
          }${router.asPath}`,
          title: title,
          description: description,
          images: [
            {
              url: "https://luminews.my/subdomain/careers/careers_seoimage.png",
              alt: "Careers - Lumi News Malaysia",
            },
          ],
        }}
      />
      <CareersPage />
    </>
  );
};

export default Careers;
